import React from 'react';
import styles from './TeamOnboardingHome.less';
import { ComponentWrapper } from 'app/src/components/ComponentWrapper';
import Icon, { IconName, IconColor } from 'app/common/components/controls/icon';
import { forNamespace } from 'app/common/lib/util/i18n';
import { Popover, usePopover } from '@trello/nachos';
import {
  ButtonTypes,
  IconButton,
} from 'app/common/components/controls/button/button';
import { TeamOnboardingMenu } from './TeamOnboardingMenu';
import { TeamOnboardingChecklist } from './TeamOnboardingChecklist';
import { TeamOnboardingMemberList } from './TeamOnboardingMemberList';

const format = forNamespace('team onboarding');

interface TeamOnboardingHomeProps {
  orgId: string;
  model: object;
  modelCache: object;
}

interface TitleProps {
  text: string;
  iconName: IconName;
  iconClassName?: string;
}

const Title: React.FC<TitleProps> = ({
  text,
  iconName,
  iconClassName = '',
}) => (
  <div className={styles.header}>
    <Icon
      className={iconClassName}
      large
      name={iconName}
      color={IconColor.Gray}
    />
    <span className={styles.headerTitle}>{text.toUpperCase()}</span>
  </div>
);

const TeamOnboardingHomeUnwrapped: React.FC<TeamOnboardingHomeProps> = ({
  orgId,
  model,
  modelCache,
}) => {
  const { triggerRef, toggle, popoverProps } = usePopover<HTMLButtonElement>();

  return (
    <div className={styles.container}>
      <div className={styles.left}>
        <div className={styles.gettingStartedBar}>
          <Title
            text={format('title')}
            iconName={IconName.Check}
            iconClassName={styles.check}
          />
          <IconButton
            className={styles.ellipsis}
            icon={IconName.OverflowMenuHorizontal}
            color={IconColor.Gray}
            buttonType={ButtonTypes.DEFAULT}
            onClick={toggle}
            ref={triggerRef}
          />
          <Popover
            {...popoverProps}
            title={format(['manage', 'popover-title'])}
          >
            <TeamOnboardingMenu orgId={orgId} />
          </Popover>
        </div>
        <TeamOnboardingChecklist orgId={orgId} />
      </div>
      <div className={styles.right}>
        <Title text={format('team members')} iconName={IconName.Organization} />
        {/* Note: because we need to use the ManageOrgMembersComponent
        and it was a lot of trouble making it work without refactoring it,
        we decided to pass down model and modelCache so we can use it.
        TODO: Remove model and modelCache once the ManageOrgMembersComponent
        had been refactored */}
        <TeamOnboardingMemberList
          orgId={orgId}
          model={model}
          modelCache={modelCache}
        />
      </div>
    </div>
  );
};

export const TeamOnboardingHome: React.FC<TeamOnboardingHomeProps> = (
  props,
) => (
  <ComponentWrapper>
    <TeamOnboardingHomeUnwrapped {...props} />
  </ComponentWrapper>
);
